/**
 * Accounts Collection holds accounts.
 */
import _ from 'underscore';
import Api from '@/lib/api/api';
import async from 'async';
import v5_Collection from '@/collections/v5/collection';
import Account from '@/models/v5/account';

var collection = new v5_Collection();
collection.model = Account;
collection.url = function() {
    return Api.urls.accounts();
};
collection.me = function(options){
    var account;
    options = options ? options : {};
    if (this._me) {
        account = this._me;
        if (options.success) options.success(account, undefined, options);
    } else {
        account = collection.add({ type: 'account' });
        this._me = account;
        account.fetch(_.extend({ url: Api.urls.account_me() }, options));
    }
    return account;
};
collection.fetch = function(options) {
    // We set remove to 'false' because, by default, the /accounts
    // endpoint shows only the accounts we have access to. It is also
    // possible to retrieve an account based on account name by filtering
    // on name, but these responses won't show up in the unflitered
    // request. If we have previously fetched these, we don't want to
    // remove them from the collection.
    var defaults = {
        remove: false
    };
    options = options ? options : {};
    _.defaults(options, defaults);
    return v5_Collection.prototype.fetch.call(this, options);
};
collection.fetch_by_uuid = function(uuid, options) {
    var account = new Account();

    options = (options || {});
    options.url = Api.urls.account({ id: uuid });

    var success = options.success;
    options.success = _.bind(function(model, response, options) {
        this.add(model);
        if (success) { success(model, response, options); }
    }, this);

    return account.fetch(options);
};
collection.fetchByName = function(name, options) {
    name = (name || "");
    options = (options || {});
    options = _.extend({
        remove: false,
        data: { 'filter[username]': 'eq:' + name.trim() }
    }, options);
    return this.fetch(options);
};
/**
 * Takes a list of UUIDs and requests account data for any UUID the app doesn't already know about
 * (makes a single request per unknown UUID)
 *
 * @param {string[]} uuid_list - Array of UUIDs that the caller wants to make sure are loaded
 * @param {function} done - Optional function that will be called when all requests are complete
 */
collection.ensure_data_loaded = function(uuid_list, done) {
    async.eachLimit(uuid_list, 5, _.bind(function(uuid, cb) {
        // If we already have the details for this account, there's nothing to do
        if (this.get(uuid)) { return cb(); }

        // If we don't, fetch the details
        this.fetch_by_uuid(uuid, {
            complete: function() { cb(); }
        });
    }, this), done);
};
export default collection;

